// IMPORTS
// Modules
import { useState, useEffect, useRef } from 'react';
// OHS
import OHSWidget from '../../../../../onehivesystems/js/OHSWidget';
import { OHSFormItem, OHSFormSubmit, OHSFormSubmitListener, OHSFormDataExtractor, OHSFormSelectBuilder } from '../../../../../onehivesystems/js/OHSForm';
import { OHSListDataFormatter } from '../../../../../onehivesystems/js/OHSList';
import OHSCRUD from '../../../../../onehivesystems/js/OHSCRUD';
// Assets
import GeneralInformation from '../../Device/Modules/GeneralInformation';
import Fields from '../../Device/Modules/Fields';


// COMPONENT
export default function Port (props) {
   // States and Variables
   const containerID = 'oneport-portcompare-port-' + Math.floor(Math.random() * 999999);
   const [ports, setPorts] = useState(null);
   const [activePort, setActivePort] = useState(null);
   const device = useRef(null);
   const port = useRef(null);

   useEffect(function () {
      // Setting activePort as "undefined" triggers a rerender of the port information so all fields populate properly
      if (activePort === undefined) {
         ports.forEach(function (item, i) {
            if (item.id.value == port.current.value) {
               setActivePort(item);
               return;
            }
         });
      }
   }, [activePort])

   // Functions
   const getPorts = function () {
      if (device.current.value != "_OHS_BLANK_") {
         OHSCRUD({
            url: '/v1/oneport/ports/' + device.current.value,
            method: 'GET',
            success: function (data) {
               setPorts(OHSListDataFormatter(data));
            },
            setOHSLoading: props.onehive.setLoading,
            setOHSPopup: props.onehive.setPopup
         });
      }
   }
   const updatePort = function () {
      OHSCRUD({
         url: '/v1/oneport/ports/' + port.current.value,
         method: 'PUT',
         payload: buildPayload(),
         success: function (data) {
            var temp = ports;
            ports.forEach(function (item, i) {
               if (item.id.value == data[0]['id']) {
                  temp[i] = OHSListDataFormatter(data[0]);
                  return;
               }
            })
            setPorts(temp);
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         showSuccessPopup: true
      });
   }
   const buildPayload = function () {
      var master = {};
      var portinfo = JSON.parse(OHSFormDataExtractor(containerID + '-portinfo'));
      master['name'] = portinfo.name;
      master['port_type'] = portinfo.port_type;
      master['mapped_device'] = portinfo.mapped_device;
      master['expiration'] = portinfo.expiration;
      master['unusable'] = portinfo.unusable;
      master['fields'] = JSON.parse(OHSFormDataExtractor(containerID + '-fields'));;
      return JSON.stringify(master);
   }

   // Component
   return (
      <div className='oneport-portcompare-port' onKeyDown={(e) => {OHSFormSubmitListener(e, updatePort);}}>
         <div className='oneport-portcompare-port-selection'>
            <OHSFormItem onehive={props.onehive} title="Device">
               <OHSFormSelectBuilder onehive={props.onehive} refObject={device} id="oneport-portcompare-port-selection-device" content={props.parent.devices} field={"name"} blank={true} onchange={getPorts} />
            </OHSFormItem>
            <OHSFormItem onehive={props.onehive} title="Port">
               <OHSFormSelectBuilder onehive={props.onehive} refObject={port} content={ports} field={"name"} blank={true} onchange={() => {setActivePort(undefined);}} />
            </OHSFormItem>
         </div>
         <OHSWidget onehive={props.onehive} id={`${containerID}-portinfo`} title="General Information">
            {activePort && <GeneralInformation onehive={props.onehive} parent={{
               content: activePort,
               devices: props.parent.devices
            }} />}
         </OHSWidget>
         <OHSWidget onehive={props.onehive} id={`${containerID}-fields`} title="Fields">
            {activePort && activePort.unusable.value === 1 && <p className='oneport-portcompare-port-fieldsdisabled'>--- Port marked as broken/unusable - Editing of fields is not available ---</p>}
            {activePort && props.parent.fields && props.parent.fields.length > 0 && props.parent.fields.map(function (field, i) {
               return (
                  <OHSFormItem onehive={props.onehive} key={`oneport-port-${props.index}-field-${i}`} title={field.name}>
                     <Fields onehive={props.onehive} parent={{
                        type: field.type,
                        defaultvalue: activePort[field.id].value,
                        disabled: activePort.unusable.value === 1,
                        ohsformdata: field.id,
                        selectContent: field.options && field.options.split("\n"),
                        selectSimple: true,
                        selectBlank: true
                     }} />
                  </OHSFormItem>
               );
            })}
         </OHSWidget>
         <OHSFormSubmit onehive={props.onehive} update={updatePort} keyListener={true} />
      </div>
   );
}